import './GraphVisualization.scss';

export { uiSchema, getSchema } from '../../schemas/GraphVisualizationSchema';

export { default } from './GraphVisualization';
